import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.membershipApiUrl;
const sessionURI = config.sessionApiUrl;

// OTP 대기 토큰 (세션 아님). Vuex state 는 IndexedDB 에 영구 저장되므로 모듈 메모리에만 둔다.
// 쿠키·localStorage 에도 저장하지 않는다 -> OTP 화면 새로고침 시 다시 로그인.
const OTP_PENDING_HEADER = 'X-Otp-Pending';
let otpPendingToken = '';
const otpHeaders = () => (otpPendingToken ? { [OTP_PENDING_HEADER]: otpPendingToken } : {});

const membershipStoreModule = {
  namespaced: true,

  state: {
    memberinfo: {},
    sessioninfo: {},
    status: false,
    compPutStatus: false,
    hash: '',
  },
  mutations: {
    SET_STORE_MEMBER_INFO(state, memberinfo) {
      state.memberinfo = memberinfo;
    },
    SET_STORE_SESSION_INFO(state, sessioninfo) {
      state.sessioninfo = sessioninfo;
    },
    SET_STORE_MEMBER_INFO_STATUS(state, status) {
      state.status = status;
    },
    SET_STORE_MEMBER_INFO_COMP_PUT_STATUS(state, compPutStatus) {
      state.compPutStatus = compPutStatus;
    },
    SET_STORE_MEMBER_HASH(state, hash) {
      state.hash = hash;
    },
  },
  actions: {
    login: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/login`, params, {
          withCredentials: true,
        });
        // console.log(response.data);
        // OTP 2단계가 필요하면 아직 로그인 완료가 아니므로 hash 로 저장하지 않는다
        const loginPending = response.data && (response.data.mfaRequired || response.data.otpLocked);
        otpPendingToken = (response.data && response.data.mfaRequired && response.data.otpToken) || '';
        commit('SET_STORE_MEMBER_HASH', loginPending ? '' : response.data);
        if (!response.data || !response.data.otpToken) return response.data;
        // 토큰은 화면(컴포넌트)으로 넘기지 않는다
        const { otpToken, ...rest } = response.data;
        return rest;
      } catch (err) {
        otpPendingToken = '';
        commit('SET_STORE_MEMBER_HASH', '');
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    // OTP 2단계: 대기 토큰을 X-Otp-Pending 헤더로 전달 (UI 와 membership 이 다른 사이트라 쿠키 불가).
    // qrDataUri / manualKey 는 화면 표시용으로만 반환하고 store 에 저장하지 않는다.
    otpSetup: async () => {
      const response = await axios.get(`${baseURI}/membership/otp/setup`, {
        headers: otpHeaders(),
      });
      if (response.data && response.data.restart) otpPendingToken = '';
      return response.data;
    },
    otpVerify: async ({ commit }, params) => {
      const response = await axios.post(`${baseURI}/membership/otp/verify`, params, {
        withCredentials: true,
        headers: otpHeaders(),
      });
      // 성공·재시작이면 서버에서 대기 상태가 폐기됐으므로 토큰도 버린다
      if (response.data && (response.data.success || response.data.restart)) otpPendingToken = '';
      if (response.data && response.data.success) {
        commit('SET_STORE_MEMBER_HASH', response.data.hash);
      }
      return response.data;
    },
    checkAuthToken: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/checkAuthToken`, params, {
          withCredentials: true,
        });
        // console.log(response.data);
        commit('SET_STORE_MEMBER_HASH', response.data);
        return response.data;
      } catch (err) {
        commit('SET_STORE_MEMBER_HASH', '');
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    logout: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${sessionURI}/session/logout`, params, {
          withCredentials: true,
        });
        // console.log(response.data);
        commit('SET_STORE_MEMBER_HASH', '');
        commit('SET_STORE_SESSION_INFO', {});
      } catch (err) {
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    getSessionInfo: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${sessionURI}/session/info`, params, {
          withCredentials: true,
        });
        // console.log(response.data);
        commit('SET_STORE_SESSION_INFO', response.data);
      } catch (err) {
        commit('SET_STORE_SESSION_INFO', {});
        // console.log(ex);
        throw err;
      }
    },
    changeSession: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${sessionURI}/session/change`, params, {
          withCredentials: true,
        });
        // console.log(response.data);
        commit('SET_STORE_MEMBER_HASH', response.data);
      } catch (err) {
        commit('SET_STORE_MEMBER_HASH', '');
        // alert(err);
        // console.log(ex);
        throw err;
      }
    },
    getMemberInfo: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/info`, params);
        // console.log(response.data);
        commit('SET_STORE_MEMBER_INFO', response.data);
      } catch (err) {
        commit('SET_STORE_MEMBER_INFO', {});
        // console.log(ex);
        throw err;
      }
    },
    putMemberInfo: async ({ commit }, params) => {
      try {
        if (params.usrId && params.usrId != '') {
          let emailArr = params.usrId.split('@');
          params.compId = emailArr[1];
        }
        // const response = await axios.post(`${baseURI}/membership/insert`, params);
        const response = await axios.post(`${baseURI}/membership/insert`, params);
        // console.log(response.data);
        commit('SET_STORE_MEMBER_INFO_STATUS', true);
        // alert(`response.data.compInfo: [${response.data.compInfo}]`);
        if (response.data.compInfo === '') {
          commit('SET_STORE_MEMBER_INFO_COMP_PUT_STATUS', true);
        } else {
          commit('SET_STORE_MEMBER_INFO_COMP_PUT_STATUS', false);
        }
        let result = {
          compId: params.compId,
          isExist: response.data.isExist,
        };
        return result;
      } catch (err) {
        // console.log(ex);
        commit('SET_STORE_MEMBER_INFO_STATUS', false);
        throw err;
      }
    },
    changeExpiredPassword: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/change-expired-password`, params);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    confirmEmail: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/confirm-email`, params);
        console.log('Call API confirm email', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    resendEmail: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/membership/resend-email`, params);
        console.log('Call API resend email', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    memberinfo: (state) => state.memberinfo,
    sessioninfo: (state) => state.sessioninfo,
    status: (state) => state.status,
    compPutStatus: (state) => state.compPutStatus,
    hash: (state) => state.hash,
  },
};

export default membershipStoreModule;
